SNI.Application.addService('legal-terms-acceptance', (application) => {
  const cookieService = application.getService('cookie');
  const debug = SNI.Application.getService('logger').create('legal-terms-acceptance');
  const util = application.getService('utility');
  const brandService = application.getService('getBrand');
  
  let ack_terms = util.getUrlParam(window.location.href, 'ack_terms');
  let referrer = document.referrer || '';

  debug.log('UCL config', window.SNI.UserConsentConfig);

  function getReferrerBrand() {
    // remove protocol, trailing slash and www, then split by .
    let referrerSplit = referrer.replace(/^https?:\/\/(www\.)?/, '').replace('/', '').split('.');
    if (referrerSplit.length > 0) {
      // return the portion before .com
      return referrerSplit[referrerSplit.length-2];
    }
    return '';
  }

  function isReferrerValid() {
    let valid = false;
    let refBrand = getReferrerBrand();
    valid = refBrand && brandService.isSisterSite(refBrand);
    debug.log('Referrer check', referrer, 'brand', brandService.specific('long'), 'valid', valid);
    if (valid) localStorage.setItem('dsLTP', 'referrer_link');
    return valid;
  }

  function setLTPCookie() {
      // First, check if we have already set the DS LTP ack in localStorage
      let checkCachedAck = hasDSLTPStorage();
      if (checkCachedAck) {
        debug.log('LTP already set in localStorage, skipping set.');
        return;
      }
      debug.log('Setting third party LTP cookie for use in other sites.');
      // Use a different name for the LTP cookie to avoid conflicts with existing cookies
      // Cookie is set to last 1 year
      fetch(`${SNI.Config.termsConfig.endpoint}/terms/set`, {
        method: 'GET',
        credentials: 'include' // Include cookies in the request
      }).then(async (response) => {
        let {status} = response;
        let txt= '';
        if (status !== 200) {
          throw new Error(`Failed to set LTP cookie, status code: ${status}`);
        } else {
          txt = await response.json();
          localStorage.setItem('dsLTP', txt);
        }

        debug.log('LTP cookie set for third party use', txt);
      }).catch(error => {
        debug.error('Error setting LTP cookie for third party use', error);
      });
  }

  /* 
    Check for DS LTP Ack in localStorage
  */
  function hasDSLTPStorage(){
    // Force the display of the terms acceptance if ack_terms=0 is in the URL
    let forceAck = ack_terms === '0';
    if (forceAck) return false;
    let hasSessionAck = localStorage.getItem('dsLTP');
    if (hasSessionAck) debug.log('Using cached acknowledgement.');
    return !!hasSessionAck;
  }

  async function hasDSLTPAck() {
    // First, check localStorage for cached ackknowledgement
    let cachedAck = hasDSLTPStorage();
    let dsLTP = { txt: null, status: 0}; 
    let dsLTPOK = false;
    if (!cachedAck) {
      try {
        dsLTP = await checkForLTPCookie();
        dsLTPOK = dsLTP?.status === 200;
      } catch (e) {
        debug.error('Error checking for LTP cookie', e);
      }
      // If still no ack, check referrer
      if (!dsLTPOK) {
        let referrerValid = isReferrerValid();
        if (referrerValid) {
          dsLTP = { txt: 'referrer_link', status: 200};
          dsLTPOK = true;
        }
      }
    } else {
      dsLTP = { txt: localStorage.getItem('dsLTP'), status: 200};
    }
    return dsLTP;
  }

  /* 
    Check for WBD LTP Ack in localStorage or cookie
    The wbdLTP is set by the UCL library and is accessible
    programmatically.
  */
  function hasWBDLTPAck() {
    let wbdLTPLS = localStorage.getItem('wbdLTP');
    let wbdLTP;
    if (!wbdLTPLS) {
      wbdLTP = cookieService.get('wbdLTP') || null;
    }
    return wbdLTPLS || wbdLTP; 
  }

  async function checkForLTPCookie() {
    let dsLTP = { txt: null, status: 0}; 
    let dsLTPOK = false;
    let res;
    try {
      res = await fetch(`${SNI.Config.termsConfig.endpoint}/terms/status`, {
        method: 'GET',
        credentials: 'include' // Include cookies in the request
      });
    } catch (e) {
      debug.error('Error on /terms/status', e);
      dsLTP.status = 400;
    }
    if (res && res.status === 200) {
      dsLTP = { txt: await res.json(), status: res.status} ;
      dsLTPOK = dsLTP?.txt !== '' && dsLTP?.txt !== null;
      debug.log('LTP cookie check', dsLTP);
      if (dsLTPOK) localStorage.setItem('dsLTP', dsLTP.txt);
    }
    return dsLTP;
  }

  return {
    setLTPCookie,
    checkForLTPCookie,
    hasWBDLTPAck,
    hasDSLTPAck,
    log(...params) { debug.log(...params); }  // expose log for use outside of Core JS
  };
});